import React, { useEffect, useRef, useState } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import Header from '../../components/Header';
import Nav from '../../components/Nav';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { endpointApi } from '../../utils';
import { setLoading } from '../../redux/actions/loader.action';
import { logout } from '../../redux/actions/auth.action';
import { getCategories } from '../../redux/actions/category.action';
import Paginate from '../../components/Paginate';

export default function CategoriesPage() {
    const jwt_access = localStorage.getItem('jwt_access');
    const { me } = useSelector(state => state.auth);
    const categories = useSelector(state => state.categories);
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();

    const addModalRef = useRef(null);
    const updateModalRef = useRef(null);
    const detailsModalRef = useRef(null);

    const [category, setCategory] = useState(null);
    const [modal, setModal] = useState(null);
    const [actionModal, setActionModal] = useState(null);

    const [name, setName] = useState("");
    const [description, setDescription] = useState("");
    const [isNameTouched, setIsNameTouched] = useState(false);
    const [isDescriptionTouched, setIsDescriptionTouched] = useState(false);

    const [errors, setErrors] = useState(null);

    useEffect(() => {
        dispatch(getCategories(location, navigate));
    }, [location, navigate, dispatch]);

    useEffect(() => {
        const clickModalOutside = (e) => {
            if((addModalRef.current && addModalRef.current === e.target && addModalRef.current.classList.contains('active')) || (updateModalRef.current && updateModalRef.current === e.target && updateModalRef.current.classList.contains('active')) || (detailsModalRef.current && detailsModalRef.current === e.target && detailsModalRef.current.classList.contains('active')) || e.target.classList.contains('_modal-close')){
                setModal(null);
            }
        }
        document.addEventListener('click', clickModalOutside);
        return () => {
            document.removeEventListener('click', clickModalOutside);
        }
    }, []);

    useEffect(() => {
        const clickOutsideActionModal = (e) => {
            const $actionModals = document.querySelectorAll('.actions>ul');
            $actionModals.forEach($actionModal => {
                if($actionModal && !$actionModal.contains(e.target) && $actionModal.classList.contains('active')){
                    setActionModal(null);
                }
            });
        }
        document.addEventListener('click', clickOutsideActionModal);
        return () => {
            document.removeEventListener('click', clickOutsideActionModal);
        }
    }, []);

    useEffect(() => {
        if(modal === null){
            setName("");
            setDescription("");
            setIsNameTouched(false);
            setIsDescriptionTouched(false);
            setCategory(null);
            setErrors(null);
        }
    }, [modal]);
    
    useEffect(() => {
        if(modal === 'update' && category){
            setName(category.name);
            setDescription(category.description ? category.description : "");
        }
    }, [modal, category]);

    const handleSubmit = async(e) => {
        e.preventDefault();
        dispatch(setLoading(true));
        setErrors(null);
        const data = new FormData(e.target);
        await axios.post(`${ endpointApi }categories`, data, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${ jwt_access }`
                        }
                    })
                    .then(({ data }) => {
                        dispatch(getCategories(location, navigate));
                        setCategory(data);
                        setModal("details");
                    })
                    .catch(err => {
                        if(err.response.status === 401){
                            dispatch(logout(location.pathname + location.search, navigate));
                        }else{
                            setErrors(err.response && err.response.data && err.response.data.errors ? err.response.data.errors : {error: err.response.data && err.response.data.message ? err.response.data.message : err.message});
                        }
                    })
                    .finally(() => {
                        dispatch(setLoading(false));
                    });
    }

    const handleSubmit2 = async(e) => {
        e.preventDefault();
        dispatch(setLoading(true));
        setErrors(null);
        const data = new FormData(e.target);
        await axios.put(`${ endpointApi }categories/${ category?.id }`, data, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${ jwt_access }`
                        }
                    })
                    .then(({ data }) => {
                        dispatch(getCategories(location, navigate));
                        setCategory(data);
                        setModal("details");
                    })
                    .catch(err => {
                        if(err.response.status === 401){
                            dispatch(logout(location.pathname + location.search, navigate));
                        }else{
                            setErrors(err.response && err.response.data && err.response.data.errors ? err.response.data.errors : {error: err.response.data && err.response.data.message ? err.response.data.message : err.message});
                        }
                    })
                    .finally(() => {
                        dispatch(setLoading(false));
                    });
    }

    useEffect(() => {
        if(!jwt_access){
            navigate('/login?redirect_to=' + location.pathname + location.search);
        }
    }, [location, navigate, jwt_access]);

    return (
        me &&
        <HelmetProvider>
            <Helmet>
                <title>Catégories - Société Mikalo</title>
            </Helmet>
            
            <Header />

            <Nav />

            <main id="main">
                <div className='title d-flex justify-content-between'>
                    <h1>Catégories</h1>
                    <button type='button' onClick={ () => {
                        setModal('add');
                    } } className='btn btn-primary'><i className='fa fa-plus'></i> Ajouter</button>
                </div>

                <div ref={ addModalRef } className={ `_modal${ modal === 'add' ? ' active' : '' }` }>
                    <div className='_modal-content'>
                        <div className='_modal-head'>
                            <h4>Ajouter une catégorie</h4>
                            <button className='_modal-close'>&times;</button>
                        </div>
                        <div className='_modal-body'>
                            <form className='form' onSubmit={ handleSubmit }>
                                { errors && errors.error && <div className='alert alert-danger'>{ errors.error }</div> }
                                <div className='mb-3'>
                                    <label htmlFor='name' className='required'>Nom de la catégorie</label>
                                    <input type='text' id="name" name="name" value={ name } className='form-control' placeholder='Nom de la catégorie' required autoComplete='off' onChange={ (e) => setName(e.target.value) } onBlur={ () => setIsNameTouched(true) } />
                                    { isNameTouched && name.length === 0 && <div className='form-error'>Veuillez saisir le nom de la catégorie.</div> }
                                    { isNameTouched && name.length > 0 && name.length < 2 && <div className='form-error'>Le nom de la catégorie est trop court. Veuillez saisir au moins 2 caractères.</div> }
                                    { errors && errors.name && <div className='form-error'>{ errors.name[0] }</div> }
                                </div>
                                <div className='mb-3'>
                                    <label htmlFor='description'>Description</label>
                                    <textarea id="description" name="description" value={ description } className='form-control' placeholder='Description' onChange={ (e) => setDescription(e.target.value) } onBlur={ () => setIsDescriptionTouched(true) }></textarea>
                                    { isDescriptionTouched && description.length > 0 && description.length < 30 && <div className='form-error'>La description est trop courte. Veuillez saisir au moins 30 caractères.</div> }
                                    { errors && errors.description && <div className='form-error'>{ errors.description[0] }</div> }
                                </div>
                                <div className='pt-2 text-end'>
                                    <button type='submit' className='btn btn-lg btn-primary' disabled={
                                        name.length < 2 ||description.length < 30
                                    }><i className="fa fa-save"></i> Enregistrer</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                
                <div ref={ updateModalRef } className={ `_modal${ modal === 'update' && category ? ' active' : '' }` }>
                    <div className='_modal-content'>
                        <div className='_modal-head'>
                            <h4>Modifier une catégorie</h4>
                            <button className='_modal-close'>&times;</button>
                        </div>
                        <div className='_modal-body'>
                            <form className='form' onSubmit={ handleSubmit2 }>
                                { errors && errors.error && <div className='alert alert-danger'>{ errors.error }</div> }
                                <div className='mb-3'>
                                    <label htmlFor='name' className='required'>Nom de la catégorie</label>
                                    <input type='text' id="name" name="name" value={ name } className='form-control' placeholder='Nom de la catégorie' required autoComplete='off' onChange={ (e) => setName(e.target.value) } onBlur={ () => setIsNameTouched(true) } />
                                    { isNameTouched && name.length === 0 && <div className='form-error'>Veuillez saisir le nom de la catégorie.</div> }
                                    { isNameTouched && name.length > 0 && name.length < 2 && <div className='form-error'>Le nom de la catégorie est trop court. Veuillez saisir au moins 2 caractères.</div> }
                                    { errors && errors.name && <div className='form-error'>{ errors.name[0] }</div> }
                                </div>
                                <div className='mb-3'>
                                    <label htmlFor='description'>Description</label>
                                    <textarea id="description" name="description" value={ description } className='form-control' placeholder='Description' onChange={ (e) => setDescription(e.target.value) } onBlur={ () => setIsDescriptionTouched(true) }></textarea>
                                    { isDescriptionTouched && description.length > 0 && description.length < 30 && <div className='form-error'>La description est trop courte. Veuillez saisir au moins 30 caractères.</div> }
                                    { errors && errors.description && <div className='form-error'>{ errors.description[0] }</div> }
                                </div>
                                <div className='pt-2 text-end'>
                                    <button type='submit' className='btn btn-lg btn-primary' disabled={
                                        name.length < 2 || description.length < 30
                                        || (category && category.name === name && category.description === description)
                                    }><i className="fa fa-save"></i> Mettre à jour</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                
                <div ref={ detailsModalRef } className={ `_modal${ modal === 'details' && category ? ' active' : '' }` }>
                    <div className='_modal-content'>
                        <div className='_modal-head'>
                            { category &&
                            <h4>#{ category.id } - { category.name }</h4> }
                            <button className='_modal-close'>&times;</button>
                        </div>
                        <div className='_modal-body'>
                            { category && <>
                                <div className='mb-3'>
                                    <div className='_label'>#ID</div>
                                    <div className='_value'>#{ category.id }</div>
                                </div>
                                <div className='mb-3'>
                                    <div className='_label'>Nom de la catégorie</div>
                                    <div className='_value'>{ category.name }</div>
                                </div>
                                <div className='mb-3'>
                                    <div className='_label'>Description</div>
                                    <div className='_value'>{ category.description ? category.description : '-' }</div>
                                </div>
                                <div className='pt-2 text-end'>
                                    <button type='button' className='btn btn-lg btn-primary' onClick={ () => setModal("update") }><i className='fa fa-edit'></i> Modifier</button>
                                </div>
                            </> }
                        </div>
                    </div>
                </div>

                <div className='box'>
                    <table className='table table-striped'>
                        <thead>
                        <tr>
                            <th width="100">#ID</th>
                            <th>Nom de la catégorie</th>
                            <th width="75" className="text-end">Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                            { categories.loading && <tr><td colSpan={ 3 }>Chargement...</td></tr> }
                            { categories.loading === false && categories.data && categories.data.total === 0 && <tr><td colSpan={ 3 }>Aucun élément trouvé</td></tr> }
                            { categories.loading === false && categories.data && categories.data.data && categories.data.data.map((item, index) => {
                            return (
                            <tr key={ index }>
                                <td>#{ item.id }</td>
                                <td>{ item.name }</td>
                                <td className='text-end'>
                                    <div className='actions'>
                                        <button type='button' className='toggle-action' onClick={ (e) => {
                                        e.stopPropagation();
                                        setActionModal(actionModal !== item.id ? item.id : null);
                                        } }><i className='fa fa-ellipsis-v'></i></button>
                                        <ul className={ actionModal === item.id ? 'active' : '' }>
                                        <li><button onClick={ () => {
                                            setModal("details");
                                            setActionModal(null);
                                            setCategory(item);
                                        } }><i className='fa fa-eye'></i> Voir les détails</button></li>
                                        <li><button type='button' onClick={ () => {
                                            setActionModal(null);
                                            setCategory(item);
                                            setModal("update");
                                        } }><i className='fa fa-edit'></i> Modifier</button></li>
                                        </ul>
                                    </div>
                                </td>
                            </tr> ) })}
                        </tbody>
                    </table>
                </div>
                    
                { categories && categories.data &&
                <Paginate currentPage={ categories.data.current_page } totalPages={ categories.data.last_page } pathname={ location.pathname } search={ location.search } /> }
            </main>
        </HelmetProvider>
    )
}
